{
  "possibleTypes": {
    "ActivitiesAnswer": [
      "DrawAnswer",
      "ImageAnswer",
      "InteractiveResponseAnswer",
      "MultipleChoiceAnswer",
      "RichtextAnswer"
    ],
    "ActivitiesAnswerInterface": [
      "DrawAnswer",
      "ImageAnswer",
      "InteractiveResponseAnswer",
      "MultipleChoiceAnswer",
      "RichtextAnswer"
    ],
    "ActivitiesComponentInterface": [
      "ActivitiesActivityComponent",
      "ActivitiesAudioComponent",
      "ActivitiesCategoriseResponseComponent",
      "ActivitiesColumnsComponent",
      "ActivitiesDiscussionComponent",
      "ActivitiesDocumentComponent",
      "ActivitiesDrawComponent",
      "ActivitiesEbookComponent",
      "ActivitiesEquationResponseComponent",
      "ActivitiesFillInBlanksResponseComponent",
      "ActivitiesGifComponent",
      "ActivitiesGuidedResearchComponent",
      "ActivitiesImageComponent",
      "ActivitiesImageSphereComponent",
      "ActivitiesInfoBoxComponent",
      "ActivitiesInteractiveComponent",
      "ActivitiesInteractiveEbookComponent",
      "ActivitiesInteractiveResponseComponent",
      "ActivitiesLinkComponent",
      "ActivitiesMultipleChoiceComponent",
      "ActivitiesResponseComponent",
      "ActivitiesRichtextComponent",
      "ActivitiesRiveAnimationComponent",
      "ActivitiesSlideshowComponent",
      "ActivitiesTableComponent",
      "ActivitiesVideoComponent",
      "ActivitiesVocabularyComponent",
      "ActivitiesWebToolComponent"
    ],
    "ActivitiesInterface": [
      "AssessmentActivities",
      "LessonActivities"
    ],
    "ActivitiesSuggestedAnswerInterface": [
      "ActivitiesActivityComponent",
      "ActivitiesCategoriseResponseComponent",
      "ActivitiesDiscussionComponent",
      "ActivitiesDrawComponent",
      "ActivitiesEquationResponseComponent",
      "ActivitiesFillInBlanksResponseComponent",
      "ActivitiesInteractiveResponseComponent",
      "ActivitiesMultipleChoiceComponent",
      "ActivitiesResponseComponent",
      "ActivitiesTableComponent"
    ],
    "ActivityContent": [
      "AssessmentActivities",
      "LessonActivities"
    ],
    "AnnotationDetail": [
      "Assessment",
      "Lesson",
      "Unit"
    ],
    "AssignedContentData": [
      "AssignedAssessmentData",
      "AssignedLessonData"
    ],
    "AssignmentLinkedContent": [
      "Assessment",
      "Lesson"
    ],
    "ColumnableComponent": [
      "ActivitiesActivityComponent",
      "ActivitiesAudioComponent",
      "ActivitiesCategoriseResponseComponent",
      "ActivitiesDiscussionComponent",
      "ActivitiesDocumentComponent",
      "ActivitiesDrawComponent",
      "ActivitiesEbookComponent",
      "ActivitiesEquationResponseComponent",
      "ActivitiesFillInBlanksResponseComponent",
      "ActivitiesGifComponent",
      "ActivitiesGuidedResearchComponent",
      "ActivitiesImageComponent",
      "ActivitiesImageSphereComponent",
      "ActivitiesInfoBoxComponent",
      "ActivitiesInteractiveComponent",
      "ActivitiesInteractiveEbookComponent",
      "ActivitiesInteractiveResponseComponent",
      "ActivitiesLinkComponent",
      "ActivitiesMultipleChoiceComponent",
      "ActivitiesResponseComponent",
      "ActivitiesRiveAnimationComponent",
      "ActivitiesSlideshowComponent",
      "ActivitiesTableComponent",
      "ActivitiesVideoComponent",
      "ActivitiesVocabularyComponent",
      "ActivitiesWebToolComponent"
    ],
    "ContentDetails": [
      "Assessment",
      "Lesson"
    ],
    "InvalidStudentEntry": [
      "InvalidEmail",
      "InvalidStudentName"
    ],
    "PlainAnswer": [
      "BooleanPlainAnswer",
      "IntPlainAnswer",
      "StringPlainAnswer"
    ],
    "ResponseComponent": [
      "ActivitiesCategoriseResponseComponent",
      "ActivitiesDiscussionComponent",
      "ActivitiesDrawComponent",
      "ActivitiesEquationResponseComponent",
      "ActivitiesFillInBlanksResponseComponent",
      "ActivitiesInteractiveResponseComponent",
      "ActivitiesMultipleChoiceComponent",
      "ActivitiesResponseComponent",
      "ActivitiesTableComponent"
    ],
    "SectionComponent": [
      "ActivitiesActivityComponent",
      "ActivitiesAudioComponent",
      "ActivitiesCategoriseResponseComponent",
      "ActivitiesColumnsComponent",
      "ActivitiesDiscussionComponent",
      "ActivitiesDocumentComponent",
      "ActivitiesDrawComponent",
      "ActivitiesEbookComponent",
      "ActivitiesEquationResponseComponent",
      "ActivitiesFillInBlanksResponseComponent",
      "ActivitiesGifComponent",
      "ActivitiesGuidedResearchComponent",
      "ActivitiesImageComponent",
      "ActivitiesImageSphereComponent",
      "ActivitiesInfoBoxComponent",
      "ActivitiesInteractiveComponent",
      "ActivitiesInteractiveEbookComponent",
      "ActivitiesInteractiveResponseComponent",
      "ActivitiesLinkComponent",
      "ActivitiesMultipleChoiceComponent",
      "ActivitiesResponseComponent",
      "ActivitiesRiveAnimationComponent",
      "ActivitiesSlideshowComponent",
      "ActivitiesTableComponent",
      "ActivitiesVideoComponent",
      "ActivitiesVocabularyComponent",
      "ActivitiesWebToolComponent"
    ],
    "StimulusResource": [
      "StimulusResourceAudio",
      "StimulusResourceDocument",
      "StimulusResourceEBook",
      "StimulusResourceEBookInteractive",
      "StimulusResourceGuidedResearch",
      "StimulusResourceImage",
      "StimulusResourceInteractive",
      "StimulusResourceLink",
      "StimulusResourceVideo",
      "StimulusResourceWebTool"
    ],
    "StimulusResourceInterface": [
      "StimulusResourceAudio",
      "StimulusResourceDocument",
      "StimulusResourceEBook",
      "StimulusResourceEBookInteractive",
      "StimulusResourceGuidedResearch",
      "StimulusResourceImage",
      "StimulusResourceInteractive",
      "StimulusResourceLink",
      "StimulusResourceVideo",
      "StimulusResourceWebTool"
    ],
    "StudentResponse": [
      "ActivityStudentResult",
      "StudentActivityResult"
    ],
    "SubActivityComponent": [
      "ActivitiesCategoriseResponseComponent",
      "ActivitiesDiscussionComponent",
      "ActivitiesDrawComponent",
      "ActivitiesEquationResponseComponent",
      "ActivitiesFillInBlanksResponseComponent",
      "ActivitiesInteractiveResponseComponent",
      "ActivitiesMultipleChoiceComponent",
      "ActivitiesResponseComponent",
      "ActivitiesTableComponent"
    ],
    "SubActivityComponentInterface": [
      "ActivitiesCategoriseResponseComponent",
      "ActivitiesDiscussionComponent",
      "ActivitiesDrawComponent",
      "ActivitiesEquationResponseComponent",
      "ActivitiesFillInBlanksResponseComponent",
      "ActivitiesInteractiveResponseComponent",
      "ActivitiesMultipleChoiceComponent",
      "ActivitiesResponseComponent",
      "ActivitiesTableComponent"
    ],
    "UgcComponent": [
      "UgcImageComponent",
      "UgcMultipleChoiceComponent"
    ],
    "UgcComponentInterface": [
      "UgcImageComponent",
      "UgcMultipleChoiceComponent"
    ],
    "UserContentReleaseNotificationDetail": [
      "Unit"
    ]
  }
}